import { useContext, useEffect, useRef } from 'react';
import { Product } from 'src/components/ProductDetail/utils/product-detail.types';
import { ProductPrice } from 'src/types/global-types';
import { ConfigContext } from 'src/components/AppShell/ConfigProvider';

import { getStoreName, trackViewedProduct } from '../klaviyo.utils';

type UseKlaviyoViewedProductParams = {
    product: Product;
    price: ProductPrice;
    url: string;
};

export const useKlaviyoViewedProduct = ({ product, price, url }: UseKlaviyoViewedProductParams): void => {
    const trackedRef = useRef<string | null>(null);
    const { currentCurrency } = useContext(ConfigContext);

    useEffect(() => {
        if (trackedRef.current === product.sku) {
            return;
        }

        trackedRef.current = product.sku;

        const categories = product.categories?.map((cat) => cat.name) || [];
        const imageUrl = product.small_image || product.media_entries?.[0]?.large_url;

        trackViewedProduct({
            ProductName: product.name,
            ProductID: product.id,
            SKU: product.sku,
            Categories: categories,
            ImageURL: imageUrl,
            URL: url,
            Brand: product.brand_badge || undefined,
            Price: price.price,
            CompareAtPrice: price.regular_price > price.price ? price.regular_price : undefined,
            Store: getStoreName(),
            Currency: currentCurrency.code,
        });
    }, [product, price, url, currentCurrency.code]);
};
